import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile } from '@ffmpeg/util';

const ffmpeg = new FFmpeg();

async function loadFFmpeg() {
  if (!ffmpeg.loaded) {
    try {
      await ffmpeg.load();
    } catch {
      throw new Error('FFmpeg failed to load');
    }
  }
}

function getInputFileExtension(blob: Blob): string {
  const type = blob.type;
  if (type.includes('audio/webm')) return 'webm';
  if (type.includes('audio/mp3')) return 'mp3';
  if (type.includes('audio/mp4') || type.includes('video/mp4')) return 'mp4';
  return 'unknown';
}

export async function modifyBlobToWav(blob: Blob): Promise<Blob> {
  await loadFFmpeg();

  const inputFileExtension = getInputFileExtension(blob);
  if (inputFileExtension === 'unknown') {
    throw new Error(`Unsupported file format: ${blob.type}`);
  }

  let inputFile;
  try {
    inputFile = await fetchFile(blob);
    const inputFileName = `input.${inputFileExtension}`;
    await ffmpeg.writeFile(inputFileName, inputFile);
  } catch (error) {
    throw new Error(
      `Error during file processing: ${error instanceof Error ? error.message : 'Unknown error'}`
    );
  }

  try {
    await ffmpeg.exec([
      '-i',
      `input.${inputFileExtension}`,
      '-ar',
      '22050',
      '-ac',
      '2',
      'output.wav',
    ]);
  } catch (error) {
    throw new Error(
      `FFmpeg execution failed: ${error instanceof Error ? error.message : 'Unknown error'}`
    );
  }

  let outputData;
  try {
    outputData = await ffmpeg.readFile('output.wav');
  } catch (error) {
    throw new Error(
      `Error reading output file from FFmpeg: ${error instanceof Error ? error.message : 'Unknown error'}`
    );
  }

  try {
    return new Blob([outputData as unknown as ArrayBuffer], {
      type: 'audio/wav',
    });
  } catch (error) {
    throw new Error(
      `Error creating WAV Blob: ${error instanceof Error ? error.message : 'Unknown error'}`
    );
  }
}
